// extracted by mini-css-extract-plugin
module.exports = {"title":"no-results_title__RylvJ","defaultHits":"no-results_defaultHits__Idagy","noResultsPretitle":"no-results_noResultsPretitle__SwqA1"};